import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import {  Observable} from 'rxjs';
import { BroadcastMessage } from '@model/broadcast-message';
import { environment } from '../../environments/environment';

@Injectable({ providedIn: 'root' })
export class BroadcastService {
   private readonly url = environment.broadcastUrl;
   //private readonly url = '/assets/broadcast-test.json';

  constructor(private http: HttpClient) {}

//   fetchBroadcastMessages(): Observable<BroadcastMessage[]> {
//     return this.http.get<BroadcastMessage[]>(this.url);
//   }

  fetchBroadcastMessages(): Observable<BroadcastMessage[]> {
  return new Observable(observer => {
    fetch(`${this.url}?t=${new Date().getTime()}`)
      .then(res => res.json())
      .then(data => {
        observer.next(data);
        observer.complete();
      })
      .catch(err => observer.error(err));
  });
}
}

